export class AcknowledementConstants {
    
  //Spinner Messages
  public static readonly Acknowledgement_Save_InProgress: string =
  'Save is in progress';

// Error messages
public static readonly Acknowledgement_DueDate_Required: string = 'Due Date is required.';
public static readonly Acknowledgement_Error_Message_Header_Text: string =
  'Please correct the following errors to create the Acknowledgement.';

//const values
public static readonly Acknowledgement_Default_Requiredfields = {
  dueDate: false,
};
public static readonly documentPhasenumbersToHideAcknowledgementBtn1 = [7,8,9];
public static readonly documentPhasenumbersToHideAcknowledgementBtn2 = [5, 6];
public static readonly documentEffectivePhasenumber = 6;
public static readonly documentApprovedPhasenumber = 5;


// Toaster Messages and Severity
public static readonly Severity_Success: string = 'success';
public static readonly Severity_Info: string = 'info';
public static readonly Severity_Err: string = 'error';
public static readonly Acknowledgement_Created_Success: string =
  'Acknowledgement Created Successfully';
public static readonly Acknowledgement_Creation_Failed: string =
  'Acknowledgement Failed to save';
  public static readonly Acknowledgement_Updated_Successfully_OnConfirmation_Message:string=
  'Document successfully acknowledged';

  
  // confirmation Messages
  public static readonly Acknowledgement_Slider_Confirmation_Header: string =
    'Confirmation';
  public static readonly Acknowledgement_Confirmation_Text: string =
    'Any unsaved change will be lost when closing the screen. Do you want to continue?';
    public static readonly Acknowledgement_Confirmation_Modal_Text :string=
    'You hereby confirm that the task has been performed according to applicable local procedures. This action is not reversible, do you want to proceed?';
  public static readonly Delete_Acknowledgement_success_Message : string = 
    'Acknowledgement deleted successfully'

   //Error Messages
   public static readonly ReasonErrorMessage =
   'Reason for Deletion is required';
}
